// extracted by mini-css-extract-plugin
export default {"container":"detail_container__uSyCb","title":"detail_title__RxAZU"};